import { getAddonTotalCost } from '../../../utils';






export default (({ addons, iterations = [] }) => {
  const addonsCost = Object.keys(addons).
  reduce((
  accumulator,
  key) =>
  accumulator + getAddonTotalCost({ selectedValue: addons[key] }), 0);

  const iterationsCost = getAddonTotalCost({ selectedValue: iterations, field: 'outputCost' });

  return addonsCost + iterationsCost;
});